module.exports = __webpack_public_path__ + "admin/img/user.a1c9f75.png";


//////////////////
// WEBPACK FOOTER
// ./static/user.png
// module id = s0MG
// module chunks = 1